import { RadiusID, SearchView } from '@kamernet/core/ApiClient/Kamernet';

export const MIN_AGE = 16;
export const MAX_AGE = 99;
export const DEFAULT_RADIUS_ID = RadiusID.Km10;
export const DEFAULT_SEARCH_VIEW = SearchView.List;
export const MAP_INITIAL_ZOOM = 7;
export const MAP_MARGIN = [15, 15, 15, 15];
export const HOVER_DISTANCE = 30;
export const MAP_MIN_ZOOM_DESKTOP = 10;
export const MAP_MIN_ZOOM_MOBILE = 10;
export const MAP_MAX_ZOOM = 18;
export const MAP_INITIAL_NWLAT = 54.216270703936516;
export const MAP_INITIAL_NWLNG = -3.267085312500001;
export const MAP_INITIAL_SELAT = 50.130263513834905;
export const MAP_INITIAL_SELNG = 12.5532271875;
export const MAP_INITIAL_LAT = (MAP_INITIAL_NWLAT + MAP_INITIAL_SELAT) / 2;
export const MAP_INITIAL_LNG = (MAP_INITIAL_NWLNG + MAP_INITIAL_SELNG) / 2;
export const ITEMS_PER_PAGE = 18;
